import React from 'react';
import { motion } from 'framer-motion';
import { InstagramIcon, FacebookIcon, YoutubeIcon, MailIcon, MapPinIcon, PhoneIcon } from 'lucide-react';
export function StageFooter() {
  const currentYear = new Date().getFullYear();
  return <footer className="relative w-full overflow-hidden" data-id="element-111">
      {/* Stage curtain gradient background */}
      <div className="absolute inset-0 curtain-gradient" data-id="element-112" />

      {/* Curtain drape effect - top */}
      <div className="absolute top-0 left-0 right-0 h-32" style={{
      background: `
            radial-gradient(ellipse 15% 100% at 10% 0%, rgba(139,0,0,0.3) 0%, transparent 100%),
            radial-gradient(ellipse 15% 100% at 30% 0%, rgba(139,0,0,0.2) 0%, transparent 100%),
            radial-gradient(ellipse 15% 100% at 50% 0%, rgba(139,0,0,0.3) 0%, transparent 100%),
            radial-gradient(ellipse 15% 100% at 70% 0%, rgba(139,0,0,0.2) 0%, transparent 100%),
            radial-gradient(ellipse 15% 100% at 90% 0%, rgba(139,0,0,0.3) 0%, transparent 100%)
          `
    }} data-id="element-113" />

      {/* Curtain tie-back accents */}
      <div className="absolute top-0 left-[5%] w-px h-48 bg-gradient-to-b from-[#8B0000]/40 to-transparent" data-id="element-114" />
      <div className="absolute top-0 right-[5%] w-px h-48 bg-gradient-to-b from-[#8B0000]/40 to-transparent" data-id="element-115" />

      <div className="relative z-10 pt-24 pb-12" data-id="element-116">
        <div className="max-w-7xl mx-auto px-6" data-id="element-117">
          {/* Main footer content */}
          <div className="grid md:grid-cols-12 gap-12 mb-16" data-id="element-118">
            {/* Brand column */}
            <div className="md:col-span-4" data-id="element-119">
              <motion.div initial={{
              opacity: 0,
              y: 20
            }} whileInView={{
              opacity: 1,
              y: 0
            }} viewport={{
              once: true
            }} transition={{
              duration: 0.6
            }} data-id="element-120">
                <h3 className="font-display text-4xl font-bold mb-4" data-id="element-121">
                  MOVE
                  <span className="text-white/30 italic block text-2xl" data-id="element-122">
                    in the Light
                  </span>
                </h3>
                <p className="text-white/40 text-sm leading-relaxed mb-6 max-w-xs" data-id="element-123">
                  Where every dancer becomes a performer, and every class is a
                  step closer to the spotlight.
                </p>

                {/* Social links */}
                <div className="flex gap-4" data-id="element-124">
                  {[{
                  icon: InstagramIcon,
                  label: 'Instagram'
                }, {
                  icon: FacebookIcon,
                  label: 'Facebook'
                }, {
                  icon: YoutubeIcon,
                  label: 'YouTube'
                }].map(({
                  icon: Icon,
                  label
                }) => <motion.a key={label} href="#" whileHover={{
                  scale: 1.1
                }} whileTap={{
                  scale: 0.95
                }} className="w-10 h-10 border border-white/20 flex items-center justify-center hover:border-white/40 hover:bg-white/5 transition-colors duration-300" aria-label={label} data-id="element-125">
                      <Icon className="w-4 h-4 text-white/60" data-id="element-126" />
                    </motion.a>)}
                </div>
              </motion.div>
            </div>

            {/* Quick links */}
            <div className="md:col-span-2" data-id="element-127">
              <motion.div initial={{
              opacity: 0,
              y: 20
            }} whileInView={{
              opacity: 1,
              y: 0
            }} viewport={{
              once: true
            }} transition={{
              duration: 0.6,
              delay: 0.1
            }} data-id="element-128">
                <h4 className="text-xs tracking-[0.3em] uppercase text-white/40 mb-6" data-id="element-129">
                  Studio
                </h4>
                <ul className="space-y-3" data-id="element-130">
                  {['Classes', 'Schedule', 'Instructors', 'Events'].map(item => <li key={item} data-id="element-131">
                        <a href="#" className="text-white/60 hover:text-white transition-colors duration-300 text-sm" data-id="element-132">
                          {item}
                        </a>
                      </li>)}
                </ul>
              </motion.div>
            </div>

            {/* More links */}
            <div className="md:col-span-2" data-id="element-133">
              <motion.div initial={{
              opacity: 0,
              y: 20
            }} whileInView={{
              opacity: 1,
              y: 0
            }} viewport={{
              once: true
            }} transition={{
              duration: 0.6,
              delay: 0.2
            }} data-id="element-134">
                <h4 className="text-xs tracking-[0.3em] uppercase text-white/40 mb-6" data-id="element-135">
                  Company
                </h4>
                <ul className="space-y-3" data-id="element-136">
                  {['About', 'Careers', 'Press', 'Contact'].map(item => <li key={item} data-id="element-137">
                      <a href="#" className="text-white/60 hover:text-white transition-colors duration-300 text-sm" data-id="element-138">
                        {item}
                      </a>
                    </li>)}
                </ul>
              </motion.div>
            </div>

            {/* Contact info */}
            <div className="md:col-span-4" data-id="element-139">
              <motion.div initial={{
              opacity: 0,
              y: 20
            }} whileInView={{
              opacity: 1,
              y: 0
            }} viewport={{
              once: true
            }} transition={{
              duration: 0.6,
              delay: 0.3
            }} data-id="element-140">
                <h4 className="text-xs tracking-[0.3em] uppercase text-white/40 mb-6" data-id="element-141">
                  Visit Us
                </h4>
                <ul className="space-y-4" data-id="element-142">
                  <li className="flex items-start gap-3" data-id="element-143">
                    <MapPinIcon className="w-4 h-4 text-white/40 mt-1 flex-shrink-0" data-id="element-144" />
                    <span className="text-white/60 text-sm" data-id="element-145">
                      245 West 52nd Street
                      <br data-id="element-146" />
                      New York, NY 10019
                    </span>
                  </li>
                  <li className="flex items-center gap-3" data-id="element-147">
                    <PhoneIcon className="w-4 h-4 text-white/40 flex-shrink-0" data-id="element-148" />
                    <span className="text-white/60 text-sm" data-id="element-149">
                      (212) 555-0147
                    </span>
                  </li>
                  <li className="flex items-center gap-3" data-id="element-150">
                    <MailIcon className="w-4 h-4 text-white/40 flex-shrink-0" data-id="element-151" />
                    <span className="text-white/60 text-sm" data-id="element-152">
                      hello@moveinthelight.com
                    </span>
                  </li>
                </ul>

                {/* Newsletter signup */}
                <div className="mt-8" data-id="element-153">
                  <p className="text-white/40 text-xs tracking-wider uppercase mb-3" data-id="element-154">
                    Join Our Mailing List
                  </p>
                  <div className="flex" data-id="element-155">
                    <input type="email" placeholder="Your email" className="flex-1 bg-transparent border border-white/20 px-4 py-3 text-sm text-white placeholder:text-white/30 focus:outline-none focus:border-white/40" data-id="element-156" />
                    <motion.button whileHover={{
                    scale: 1.02
                  }} whileTap={{
                    scale: 0.98
                  }} className="bg-[#DC2626] px-6 py-3 text-white text-sm tracking-wider uppercase hover:bg-[#b91c1c] transition-colors duration-300" data-id="element-157">
                      Join
                    </motion.button>
                  </div>
                </div>
              </motion.div>
            </div>
          </div>

          {/* Divider */}
          <div className="h-px bg-white/10 mb-8" data-id="element-158" />

          {/* Bottom bar */}
          <div className="flex flex-col md:flex-row justify-between items-center gap-4" data-id="element-159">
            <p className="text-white/30 text-xs" data-id="element-160">
              © {currentYear} Move in the Light Dance Studio. All rights
              reserved.
            </p>
            <div className="flex gap-6" data-id="element-161">
              {['Privacy Policy', 'Terms of Service', 'Accessibility'].map(item => <a key={item} href="#" className="text-white/30 hover:text-white/50 transition-colors duration-300 text-xs" data-id="element-162">
                    {item}
                  </a>)}
            </div>
          </div>
        </div>
      </div>

      {/* Stage floor reflection effect */}
      <div className="absolute bottom-0 left-0 right-0 h-24 pointer-events-none" style={{
      background: 'linear-gradient(to top, rgba(255,255,255,0.02) 0%, transparent 100%)'
    }} data-id="element-163" />
    </footer>;
}